import type { Identifiable } from '@empathyco/playboard-core-domain'
import type { ActionContext } from 'vuex'
import type { ActionClass, ToolingState } from '../../../models'
import type { CrudServiceProvider } from '../../../providers/interfaces'
import { EngagementActionsTypeEnum } from '@empathybroker/tsclient-stats/dist/enums/engagement/engagement-actions-type.enum'
import { CONTAINER } from '../../../config/inversify.config'
import { TYPES } from '../../../config/inversify.types'
import { FeatureIdEnum } from '../../../enums'
import { CRUD_CONSTS } from '../../crud/crud.consts'
import { TOOLING_CONSTS } from '../tooling.consts'

export class UpdateAction implements ActionClass {
  static async execute(
    this: void,
    { state, commit, dispatch }: ActionContext<ToolingState, unknown>,
    { tool, items: itemsToUpdate }: { tool: string; items: Array<Identifiable<string | number>> },
  ): Promise<Array<Identifiable<string | number>>> {
    const service = CONTAINER.get<CrudServiceProvider>(TYPES.CrudServiceProvider)(tool)
    let { results, numFound } = state.tools[tool]?.data ?? { results: [], numFound: 0 }
    const updatedItems: Array<Identifiable<string | number>> = []
    const errors: Array<unknown> = []
    for (const itemToUpdate of itemsToUpdate) {
      try {
        const updatedItem = await service.update(itemToUpdate)
        const itemIndex = results.findIndex(result => result.id === updatedItem.id)
        if (itemIndex >= 0) {
          results = [...results]
          results.splice(itemIndex, 1, updatedItem)
        } else {
          results = [...results, updatedItem]
          numFound++
        }
        updatedItems.push(updatedItem)
      } catch (error) {
        errors.push(error)
      }
    }

    if (updatedItems.length) {
      commit(TOOLING_CONSTS.mutations.setState, {
        [tool]: {
          data: {
            results,
            numFound,
          },
        },
      })

      // TODO: Delete when tagging is added to the facets tool
      if (tool !== FeatureIdEnum.FACETS) {
        await dispatch(
          `${CRUD_CONSTS.moduleName}/${CRUD_CONSTS.actions.tag}`,
          {
            featureId: tool,
            type: EngagementActionsTypeEnum.EDIT,
          },
          { root: true },
        )
      }
    }
    if (errors.length) {
      throw errors
    }
    return updatedItems
  }
}
